// extracted by mini-css-extract-plugin
module.exports = {"root":"TableTags_root__2y083","tagsGap":"TableTags_tagsGap__1wPaL","interactive":"TableTags_interactive__Ufy19"};